<template>
  <div>
    <!-- 面包屑导航 -->
  <div class="flexc-cen-x fixed">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>类别</el-breadcrumb-item>
    </el-breadcrumb>
    <el-select v-if="DianList.length>1" style="margin-left:20px;width:140px" size="mini" v-model="SelectStoresID" @change="changedian()" placeholder="门店">
      <el-option
        v-for="item in DianList"
        :key="item.ID"
        :label="item.StoresName"
        :value="item.ID">
      </el-option>
    </el-select>
  </div>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" style="width:100%;padding-top:30px">
   
        <el-button size="mini" type="primary" style="float:right"  v-if="q2 == true" icon="el-icon-plus" @click="handleEdit()">添加</el-button>

    </el-form>

    <div style="height:63vh;overflow:auto;width:100%">
      <el-table  :data="tableData" highlight-current-row v-loading="loading" size="small"  element-loading-text="拼命加载中" style="width: 100%;margin-top:10px">

          <el-table-column  prop="CommodityTypeName" label="类别名称">
            
          </el-table-column>


        <el-table-column align="center" label="操作" width="150">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.row)" v-if="q3 == true">编辑</el-button>
            <el-button size="mini" type="info" @click="deleteUser(scope.row)" v-if="q4 == true">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" :direction="direction" width="40%">
    <!-- <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click="closeDialog"> -->
        <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
            <el-form-item label="类别名称:" prop="CommodityTypeName">
            <el-input size="small" v-model="editForm.CommodityTypeName"  placeholder="请输入类别名称"  style="width: 215px"></el-input>
            </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="closeDialog">取消</el-button>
            <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">确定</el-button>
        </div>
        <!-- <div class="demo-drawer__footer flex-r-x"  style="width:30%">
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
            class="title"
        
            @click="submitForm('editForm')"
            >保存</el-button
          >
        </div> -->
    </el-dialog>



    <!-- </el-dialog> -->
      <el-dialog title="修改密码" :visible.sync="passShow" width="40%" >
      <el-form label-width="120px" :model="editForm">

        <el-form-item label="密码" prop="deptNo">
          <el-input size="small" placeholder="请输入密码" v-model="Pwd" show-password auto-complete="off"></el-input>
        </el-form-item>
      
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="topass()">保存</el-button>
      </div>
    </el-dialog>
      <el-dialog title="充值" :visible.sync="chongShow" width="40%" >
      <el-form label-width="120px">
        <el-form-item label="充值金额" prop="money">
          <el-input size="small" placeholder="请输入充值金额" v-model="money"  auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="ADDmoney()">充值</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { deptList, deptSave, deptDelete } from '../../api/userMG'
import CropperImage from "../../components/CropperImage";
import {getListManageLogin,addManageLogin,delManageLogin,editManageLogin,editManageLoginmoney,editManageLoginPwd,editManageLoginIsdisable} from "@/api/getData";
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      DianList:[],
        quanxian:false,
      formValidate: {
        mainImage: "",
      },
      props: {
          children: 'listsub',
          label: 'Name'
        },
       direction: "ltr",
      passShow:false,
      money:'',
      input:'',
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      chongShow:false,
      title: '添加',
      tableData:[],
      typeList:[],
      Pwd:'',
      RoleID:'',
      Limits:[],
      q1:false,
      q2:false,
      q3:false,
      q4:false,
      SelectStoresID:localStorage.getItem("StoresID"),
      editForm: {
        preferentialType:2,
        CommodityTypeName:'',
        preferentialvalue:'',
      },
      // rules表单验证

      rules: {
        CommodityTypeName: [{ required: true, message: '请输入类别名称', trigger: 'blur' }],
        //   Phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        //   Name: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        //   pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        //   money: [{ required: true, message: '请输入余额', trigger: 'blur' }],
        //   ShopName: [{ required: true, message: '请输入商户名称', trigger: 'blur' }],
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
          WZYGName:'',
    WZHYName:'',
    WZXMName:'',
    WZPBName:'',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination,
     CropperImage,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
        this.WZYGName = localStorage.getItem('WZYGName')
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZXMName')
    this.WZPBName = localStorage.getItem('WZPBName')
     if(localStorage.getItem('isAdmin') == 1){

          this.q1 = true
          this.q2 = true
          this.q3 = true
          this.q4 = true

      }
      this.Limits = localStorage.getItem('Limits')
      this.Limits = this.Limits.split(',')
      this.Limits.forEach(items => {

            if(items == 91)
            this.q1  =true
            if(items == 92)
            this.q2 = true
            if(items == 93)
            this.q3 = true
            if(items == 94)
            this.q4 = true


      })
    //    this.getType()
    this.getList()
    this.getDianList()
    //   this.getList()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
        getDianList(){
       var data = { 
         SelectStoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID")
      }
        var that = this
       this.ajax('getListStores.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.DianList =res.data
               
            }

      })
},

  changedian(){
      this.pageparm ={
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
    
      this.getList()
    },
        deleteUser(row){
        this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { 
            SelectStoresID:this.SelectStoresID,
            StoresID:localStorage.getItem("StoresID"),
            token: localStorage.getItem("token"),
            CommodityTypeID:row.ID,
        
        }
        var that = this
        this.ajax('delCommodityType.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });
        
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
            ;
        });
   
    },

    handleEdit(row){
          if (row != undefined && row != 'undefined') {
              this.title = '编辑商品类别'
       
              this.editForm = row
              this.editForm.CommodityTypeName = this.editForm.CommodityTypeName
            //   this.editForm.preferentialType = Number(this.editForm.preferentialType) 
    
          } else {
              this.title = '添加商品类别'
                this.editForm = {
                    preferentialType:2,
                    CommodityTypeName:'',
                    preferentialvalue:100,
                }
          }
          this.editFormVisible = true
    },
    handlePassword(){
        this.quanxian = true
    },

    handleCheckChange(data, checked, indeterminate) {
        console.log(data, checked, indeterminate);
         console.log(this.$refs.tree.getCheckedNodes());
      },

    getList(){

    //  this.tableLoading = true
       var data = { 
        SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:this.formInline.page,
          psize:this.formInline.limit,

      }
       const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      
        var that = this
      this.ajax('getListCommodityType.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.tableData = res.data
               that.pageparm.total = res.allcount

                 loading.close();
          } 

      })
  
    },

    // 获取公司列表

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getList()
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面

    // 编辑、增加页面保存方法
    submitForm(editData) {

      this.$refs[editData].validate(valid => {
        if (valid) {
            var data = this.editForm
                 data.CommodityTypeName = this.editForm.CommodityTypeName
                data.token=localStorage.getItem("token")
                data.StoresID=localStorage.getItem("StoresID")
                data.SelectStoresID  = this.SelectStoresID
                var that = this
            if(this.title == '添加商品类别'){
                this.ajax('addCommodityType.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                        that.$message({
                            type: "success",
                            message: "新建成功",duration:2000,
                        });
                        that.editFormVisible = false
                        that.getList()
                     }

                })

            }else {
                data.CommodityTypeID =  this.editForm.ID
                 this.ajax('editCommodityType.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                        that.$message({
                            type: "success",
                            message: "修改成功",duration:2000,
                        });
                        that.editFormVisible = false
                        that.getList()
                     }

                })
            }
        } else {
          return false
        }
      })
    },

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.passShow = false,
      this.chongShow = false,
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/shop/lay.vue